<template>
    <div class="products">
        <div class="products_list flex">
            <single-product
                v-for="product in products"
                :key="product.id"
                :product="product"
                :is-loan="isLoan"
            />
        </div>
        <div v-if="isMoreAvailable" class="more_wrapper text_center">
            <button
                class="btn btn_template"
                type="button"
                @click="$emit('get-more')"
            >
                טען עוד
            </button>
        </div>
    </div>
</template>

<script>
import SingleProduct from './SingleProduct';

export default {
    components: {
        SingleProduct
    },

    props: {
        products: {
            type: Array,
            required: true
        },

        total: {
            type: Number,
            required: true
        },

        isLoan: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        isMoreAvailable() {
            return this.products.length < this.total;
        }
    }
};
</script>
